import { Button, Heading, Text, VStack } from 'native-base'

import { colors } from '../../utils/theme/configureTheme'

interface MerchantDeflectionProps {
  onGoBack: () => void
}

/** Screen shown when the issue type should be directed to the merchant rather than Veho. */
export default function MerchantDeflection({ onGoBack }: MerchantDeflectionProps) {
  return (
    <VStack space={4} mt={2}>
      <Heading
        fontSize="18px"
        fontWeight="700"
        fontFamily="Matter SemiBold"
        lineHeight="125%"
        letterSpacing="-2%"
        color={colors.brand.softBlack}
      >
        We're sorry to hear about an issue with your order!
      </Heading>
      <Text fontSize={16} color={colors.brand.softBlack} lineHeight="150%">
        Veho handles delivery only. For issues with your order contents—such as wrong items, missing items, exchanges,
        or returns—please contact the merchant or retailer you ordered from directly.
      </Text>
      <Text fontSize={16} color={colors.brand.softBlack} lineHeight="150%">
        If you're experiencing a delivery-related issue instead, please go back and select a different option.
      </Text>
      <Button
        variant="outline"
        borderColor={colors.brand.vermillion}
        borderWidth={2}
        _text={{ color: colors.brand.vermillion, fontWeight: 600 }}
        onPress={onGoBack}
        alignSelf="flex-start"
      >
        Go Back
      </Button>
    </VStack>
  )
}
